"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.map.js");

var _formElements = require("@evidation/form-elements");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("./utils");

var _lodash = _interopRequireDefault(require("lodash"));

var BORDER_RADIUS = "4px";
var BLUE = "#326bfe";

var ButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "buttonGroup__ButtonContainer"
})(["width:100%;display:flex;justify-content:space-evenly;align-items:center;flex-wrap:wrap;button{padding:15px 5px;flex:1;border-color:#d6d6d6;border:1px solid #d6d6d6;background:#fff;color:", ";font-size:", "rem;font-weight:600;cursor:pointer;&.active{background:", ";border-color:", ";color:#fff;cursor:auto;}&:disabled{cursor:default;}&:first-child{border-top-left-radius:", ";border-bottom-left-radius:", ";}&:last-child{border-right:1px solid #d6d6d6;border-top-right-radius:", ";border-bottom-right-radius:", ";}@media screen and (max-width:550px){min-width:100%;border-radius:0;border:1px solid #d6d6d6;border-bottom:0;&:first-child,&:last-child{border-radius:0;}&:first-child{border-top-left-radius:", ";border-top-right-radius:", ";}&:last-child{border-bottom:1px solid #d6d6d6;border-bottom-left-radius:", ";border-bottom-right-radius:", ";}}}"], BLUE, 14 / 16, BLUE, BLUE, BORDER_RADIUS, BORDER_RADIUS, BORDER_RADIUS, BORDER_RADIUS, BORDER_RADIUS, BORDER_RADIUS, BORDER_RADIUS, BORDER_RADIUS);

var ButtonGroup = function ButtonGroup(props) {
  var _util_commonInputPara = (0, _utils.util_commonInputParamters)(props),
      labelStyle = _util_commonInputPara.labelStyle;

  var _props$input = props.input,
      onChange = _props$input.onChange,
      onBlur = _props$input.onBlur,
      _props$input$value = _props$input.value,
      value = _props$input$value === void 0 ? "" : _props$input$value,
      _props$config = props.config,
      _props$config$options = _props$config.options,
      options = _props$config$options === void 0 ? [] : _props$config$options,
      _props$config$disable = _props$config.disabled,
      disabled = _props$config$disable === void 0 ? false : _props$config$disable,
      _props$config$require = _props$config.required,
      required = _props$config$require === void 0 ? false : _props$config$require,
      label = props.label;
  return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    required: required,
    label: label,
    labelStyle: labelStyle
  }, /*#__PURE__*/_react["default"].createElement(ButtonContainer, {
    className: "buttoncontainer ".concat((0, _utils.constructFieldClassname)(props.meta))
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: option.label,
      disabled: disabled,
      className: _lodash["default"].isEqual(value, option.value) ? 'active' : '',
      id: "t-".concat(option.value),
      type: "button",
      onClick: function onClick() {
        onChange(option.value);
        onBlur();
      }
    }, option.label);
  })));
};

var _default = ButtonGroup;
exports["default"] = _default;